import { el } from 'redom';

import TextInputBox from 'generics/components/text-input/text-input-box';

import DescriptionInput from './description-input';

import './index.scss';

class BasicDetailsSection {

  constructor(configuration) {

    this.readOnly = configuration.readOnly;
    this.previousEvent = { ...configuration.event };
    this.event = { ...configuration.event };
    this.onChange = configuration.onChange || function noop() {};
    this.hideTitleInput = configuration.hideTitleInput;

    this.titleInputBox = new TextInputBox({
      disabled: this.readOnly === true,
      label: 'Title',
      placeholder: configuration.titlePlaceholder || 'An interesting task...',
      value: this.event.title,
      onChange: this.handleTitleChange.bind(this)
    });
    this.titleDisplay = el('h4.basic-details-title-display', this.event.title);
    this.descriptionInputBox = new DescriptionInput({
      eventId: configuration.event._id,
      readOnly: this.readOnly === true,
      placeholder: configuration.descriptionPlaceholder || 'Please enter description',
      value: this.event.description,
      onChange: this.handleDescriptionChange.bind(this),
      mediaUploader: configuration.mediaUploader
    });

    this.el = el('#calendar-activity-basic-details-section-main', this.getChildren());

  }

  getChildren() {

    if (this.hideTitleInput) {
      return [
        this.descriptionInputBox
      ];
    }

    if (this.readOnly === true) {
      return [
        this.titleDisplay,
        this.descriptionInputBox
      ];
    }

    return [
      this.titleInputBox,
      this.descriptionInputBox
    ];

  }

  setTitle(title) {

    this.handleTitleChange(this.event, title);

  }

  handleTitleChange(event, value) {

    this.event.title = value;

    const modified = this.event.title !== this.previousEvent.title;

    this.onChange({ value: { ...this.event }, modified });

  }

  handleDescriptionChange(value) {

    this.event.description = value;

    const modified = JSON.stringify(this.event.description) !== JSON.stringify(this.previousEvent.description);

    this.onChange({ value: { ...this.event }, modified });

  }

  getValue() {

    return this.event;

  }

  setErrors(errors) {

    for (let error of errors) {

      if (error.instancePath.indexOf('/title') !== -1) {
        this.titleInputBox.setError('Please enter title with at least 2 character');
        if (error.keyword === 'maxLength') {
          this.titleInputBox.setError('Please enter title with less than 120 characters');
        }
      } else if (error.instancePath.indexOf('/description') !== -1) {
        this.descriptionInputBox.setError('Please enter title with at least 2 character');
      }

    }

  }

  clearErrors() {

    const rows = [
      this.titleInputBox,
      this.descriptionInputBox
    ];

    for (let row of rows) {

      row.clearError();

    }

  }

}

export default BasicDetailsSection;